import { createServiceItemWithStages, getStageNote } from '~/components/BillModal/utils/lineItem.utils';
import { BillingStageType } from '~/models/manual-service-billing/model';
export const getLastBilledStageServiceItem = (param)=>{
    let { service, billingStages, t } = param;
    const nextAvailableStage = billingStages.filter((stage)=>stage.type === BillingStageType.Available).sort((a, b)=>a.stageNumber - b.stageNumber)[0];
    if (!nextAvailableStage) return null;
    const { stageNumber } = nextAvailableStage;
    return createServiceItemWithStages({
        service,
        stageNumber,
        billingStages,
        note: getStageNote({
            stagesLength: billingStages.length,
            stageNumber,
            t
        })
    });
};
